import dynamic from 'next/dynamic';
import { memo } from 'react';

import { useIsPrivateOnboardingIntroVisible } from '~/components/v2/components/workspace/onboarding-intro/hooks/useIsPrivateOnboardingIntroVisible';

const PrivateOnboardingIntro = dynamic(
  () =>
    import('~/components/v2/components/workspace/onboarding-intro/PrivateOnboardingIntro').then(
      (mod) => mod.PrivateOnboardingIntro,
    ),
  { ssr: false },
);

/**
 * Keeps the intro chunk out of the tree until the overlay will actually show.
 * Layout only composes this leaf so eligibility changes do not re-render chrome.
 */
export const PrivateOnboardingIntroMount = memo(() => {
  const { isPrivateOnboardingIntroVisible } = useIsPrivateOnboardingIntroVisible();

  if (!isPrivateOnboardingIntroVisible) {
    return null;
  }

  return <PrivateOnboardingIntro />;
});

PrivateOnboardingIntroMount.displayName = 'PrivateOnboardingIntroMount';
